import { handleActions } from 'redux-actions';
import produce from 'immer';
import { errorAllJobFunctions, loadedAllJobFunctions } from '../actions/jobFunctionActions';

export const initialState = null;

/* eslint-disable default-case, no-param-reassign */
const allJobFunctions = handleActions(
  {
    [loadedAllJobFunctions]: produce((draft, action) => {
      draft = action.payload || [];

      return draft;
    }),
    [errorAllJobFunctions]: produce((draft) => {
      draft = [];
      return draft;
    }),
  },
  initialState,
);

export default allJobFunctions;
